import { ArrayNotEmpty, IsArray, IsIn, IsInt, IsOptional } from 'class-validator';

import { OrderStatusTxt } from './order-status';

export class GetAssemblyLocationLabelsRequest {
    @IsOptional()
    @IsInt()
    public areaId?: number;

    @IsOptional()
    @IsArray()
    @ArrayNotEmpty()
    @IsIn(['new', 'pending', 'work', 'closed', 'shipped'] satisfies OrderStatusTxt[], { each: true })
    public status?: OrderStatusTxt[];

    constructor(data?: Partial<GetAssemblyLocationLabelsRequest>) {
        this.areaId = data?.areaId;
        this.status = data?.status;
    }
}
